import React from 'react';
import { useIntl } from 'react-intl';

import SelectExistingClaim from './SelectExistingClaim';
import { formatDate } from '../../../../shared';
import {
  VITOLO_EXISTING_CLAIM_OPTION_NOT_SELECTED,
  VITOLO_SELECTED_EXISTING_CLAIM,
  useNewVitoloFormDataValue,
} from '../../claimFormData/newClaimFormData';
import {
  useSelectExistingClaimVitoloBackButtonLink,
  useSelectExistingClaimVitoloNextButtonLink,
} from './selectExistingClaimVitoloHooks';

export default function SelectExistingClaimVitolo({ claims }) {
  const intl = useIntl();

  const [selectedClaimId, setSelectedClaimId] = useNewVitoloFormDataValue(
    VITOLO_SELECTED_EXISTING_CLAIM
  );

  const backButtonLink = useSelectExistingClaimVitoloBackButtonLink();
  const nextButtonLink = useSelectExistingClaimVitoloNextButtonLink(selectedClaimId);

  const claimsToList =
    Array.isArray(claims) &&
    claims.map((claim) => ({
      id: claim?.id,
      label: claim?.treatmentCategory,
      labelId: `treatment.category.${
        claim?.treatmentCategory || 'dummy_health_category_for_account_area'
      }`,
      subLabel: formatDate(claim?.lossDate),
    }));

  return (
    <SelectExistingClaim
      name="existing_claim"
      backButtonLink={backButtonLink}
      nextButtonLink={nextButtonLink}
      pageTitleId="vitolo.new_claim.existing_claims.page.title"
      claims={claimsToList}
      onSelectClaim={setSelectedClaimId}
      selectedClaimId={selectedClaimId}
      existingClaimNotSelectedKey={VITOLO_EXISTING_CLAIM_OPTION_NOT_SELECTED}
      checkboxLabel={intl.formatMessage({
        id: 'vitolo.new_claim.existing_claims.form.label.not_selected',
      })}
    />
  );
}
